import { useAuth0 } from '@auth0/auth0-react';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PreSchoolService from 'Lib/API/PreSchool';
import AlertDialog from 'components/Dialog';
import MainModal from 'components/MainModal/MainModal';
import MyModal from 'components/MyModal';
import Button from 'components/button/Button';
import React, { useCallback, useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import InternalDrawer from '../ClassInformation/InternalDrawer';
import './CreateForm.scss';
import FormTemplates from './FormTemplates/FormTemplates';
import NewQuestionForm from './NewQuestionForm/NewQuestionForm';

export default function CreateForm(props) {
  const formik = props;
  const { getAccessTokenSilently } = useAuth0();
  const [formTemplateTabType, setFormTemplateTabType] = useState("create");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [formTemplates, setFormTemplates] = useState([]);
  const [formNames, setFormNames] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteTemplateLoading, setDeleteTemplateLoading] = useState(false);
  const [confirmNavigation, setConfirmNavigation] = useState(false);
  const [openCreateFormModal, setOpenCreateFormModal] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [getFormsLoading, setGetFormsLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ open: false, isLoading: false });
  const [duplicateTemplateName, setDuplicateTemplateName] = useState("");

  const getForms = async () => {
    setGetFormsLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const response = await PreSchoolService.getForms({ token, search: searchValue, type: "education" });
      const formTempl = response?.result
        ?.map((item) => item?.task_data);
      setFormTemplates(formTempl);
      setFormNames(
        response?.result
          ?.map((item) => ({ form_name: item?.form_name, id: item?._id }))
      );
      const findFormId = response?.result?.findIndex(item => item?._id === formik?.values?.formId)
      if (!formik?.values?.formId || findFormId === -1) {
        const defaultFormId = response?.result?.length ? response?.result?.[0]?._id || "" : "";
        formik.setFieldValue("formId", defaultFormId)
      }
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setGetFormsLoading(false);
    }
  };

  const navigateIntoCreateFormHandler = () => {
    setOpenCreateFormModal(true)
    setFormTemplateTabType("create")
    setSelectedTemplate(null)
  }
  const backToTemplatesHandler = () => {
    setConfirmNavigation(false)
    setOpenCreateFormModal(false)
  }


  const updateTemplateHandler = () => {
    if (!selectedTemplate?.id) return;
    setFormTemplateTabType("update")
    setOpenCreateFormModal(true)
  }

  const deleteTemplateConfirmHandler = () => {
    setConfirmDelete(true)
  }
  const deleteTemplateHandler = async () => {
    if (!selectedTemplate?.id) return;
    setDeleteTemplateLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const response = await PreSchoolService.deleteTemplateForm(
        token,
        selectedTemplate?.id
      );
      if (!response?.result?._id) return;
      const selectedTemplateIndex = formNames.findIndex((item) => item?.id === selectedTemplate?.id);
      setFormNames((prev) => {
        const newNames = [...prev];
        newNames.splice(selectedTemplateIndex, 1);
        return newNames;
      })
      setFormTemplates((prev) => {
        const newTemplates = [...prev];
        newTemplates.splice(selectedTemplateIndex, 1);
        return newTemplates;
      })

      if (selectedTemplate?.id === formik?.values?.formId) {
        formik.setFieldValue("formId", formNames?.[0]?.id || "")
      }
      toastr.success("Success", "Template deleted successfully");
      setConfirmDelete(false);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setDeleteTemplateLoading(false);
    }
  }

  const onDuplicateTemplate = () => {
    setConfirmOpen({
      open: true,
      isLoading: false,
    });
    setDuplicateTemplateName(selectedTemplate?.form_name + "-Copy");
  }

  const duplicateTemplateHandler = async () => {
    if (!selectedTemplate?.id  || confirmOpen.isLoading) return;
    if (!duplicateTemplateName) {
      return toastr.info("Validation", "Template name is required");
    }
    setConfirmOpen((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    });
    try {
      const token = await getAccessTokenSilently();
      const payload = {
        id: selectedTemplate?.id,
        formName: duplicateTemplateName,
      }
      const response = await PreSchoolService.duplicateTemplateForm({
        token,
        payload,
    });
      toastr.success("Success", "Template duplicated successfully");
      onCloseConfirmDialog();
      getForms();
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setConfirmOpen((prev) => {
        return {
          ...prev,
          isLoading: false,
        };
      });
    }
  }


  const handleCreateAndUpdateSuccess = () => {
    setOpenCreateFormModal(false)
    setSelectedTemplate(null)
    setFormTemplateTabType("create")
    getForms()
  }

  const onCloseConfirmDialog = () => {
    setConfirmOpen({
      open: false,
      isLoading: false,
    });
  };


  return (
    <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
          <div className="info_title d-flex justify-content-between align-items-center">
            <div>
              <h2>Form</h2>
              <p>Please select a form</p>
            </div>
            <Button
              onClick={navigateIntoCreateFormHandler}
              size="md"
              variant="primary"
            >
              Create New Form Template
            </Button>
          </div>
          <div className="classTap_content">
            <FormTemplates
              formik={formik}
              updateTemplateHandler={updateTemplateHandler}
              deleteTemplateConfirmHandler={deleteTemplateConfirmHandler}
              setSelectedTemplate={setSelectedTemplate}
              formTemplates={formTemplates}
              formNames={formNames}
              getForms={getForms}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              loading={getFormsLoading}
              onDuplicateTemplate={onDuplicateTemplate}
            />
          </div>
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik} />
      </div>
      <AlertDialog
        open={confirmDelete}
        onDecline={() => {
          setConfirmDelete(false);
        }}
        onAccept={deleteTemplateHandler}
        loading={deleteTemplateLoading}
        title={"Are you sure?"}
        description={`Do you want to delete this template?`}
      />
      <AlertDialog
        open={confirmNavigation}
        handleClose={() => setConfirmNavigation(false)}
        onDecline={() => {
          setConfirmNavigation(false);
        }}
        onAccept={backToTemplatesHandler}
        title="Are you sure?"
        description={"Do you want to discard the changes you made?"}
      />
      <MyModal
        className={"new-charge-modal"}
        open={openCreateFormModal}
        onClose={() => {
          setConfirmNavigation(true);
        }}
      >
        <NewQuestionForm
          formik={formik}
          selectedTemplate={selectedTemplate}
          type={formTemplateTabType}
          handleCreateAndUpdateSuccess={handleCreateAndUpdateSuccess}
        />
      </MyModal>
      <MainModal
        open={confirmOpen.open}
        onDecline={onCloseConfirmDialog}
        onAccept={() => {
          duplicateTemplateHandler();
        }}
        loading={confirmOpen.isLoading}
        title={"Are you sure?"}
        inputField={true}
        inputFieldLabel={"Template Name"}
        inputFieldName={"template_name"}
        inputFieldValue={duplicateTemplateName}
        onChange={(e) => {
          setDuplicateTemplateName(e.target.value);
        }}
      />
    </div>
  );
}
